import { HttpContextToken } from '@angular/common/http';

/**
 * Opts a request out of the global 401 -> login redirect behavior in ApiErrorInterceptor.
 *
 * Some requests intentionally probe authentication state (for example /api/auth/me during
 * app bootstrap). Those callers need to receive the raw 401 so they can treat it as
 * "no current user" rather than triggering a user-visible auth error and redirect loop.
 */
export const SUPPRESS_UNAUTHORIZED_REDIRECT = new HttpContextToken<boolean>(() => false);
